import mockjs from 'mockjs'
// import {Request, Response} from 'express'

const getData = (req, res ) => {
  res.json({
      data:'1'
  })
}

export default {
    'GET /api/tags': mockjs.mock({
        'list|100': [{ name: '@city', 'value|1-100': 50, 'type|0-2': 1 }],
    }),
    // 'GET /api/data':getData
}
